var bt_visual = new Swiper(".bt_visual .mySwiper", {
  effect: 'fade',
  speed: 800,
  loop: true,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

gsap.registerPlugin(ScrollTrigger);

// 초기 설정
const slides = document.querySelectorAll('.device_tabs .swiper-slide');
const prdWrap = document.querySelector(".prd_wrap");
const tabs = document.querySelector(".device_tabs");
const tabButtons = tabs.querySelectorAll(".device_tabs .swiper-slide");
const sections = document.querySelectorAll(".device_section");
const titleEl = document.querySelector(".device_name");
const prdInner = document.querySelector(".prd_inner");
const prdInnerTop = prdInner.getBoundingClientRect().top + window.pageYOffset;
const prdInnerHeight = prdInner.offsetHeight;

let forcedTabIndex = null; // 탭 클릭 중인지 여부를 체크

// 탭 클릭 시 클래스 변경
slides.forEach((slide) => {
  slide.addEventListener('click', () => {
    slides.forEach(s => s.classList.remove('active'));
    slide.classList.add('active');
  });
});

// 탭 클릭 시 스크롤 이동 및 ScrollTrigger 갱신
tabButtons.forEach((btn, idx) => {
  btn.addEventListener("click", () => {
    forcedTabIndex = idx;

    const section = sections[idx];
    const scrollY = window.pageYOffset;
    const targetY = section.getBoundingClientRect().top + scrollY;
    const headerHeight = 170;
    const offset = tabs.offsetHeight + headerHeight;

    window.scrollTo({
      top: targetY - offset,
      behavior: "smooth"
    });

    tabButtons.forEach(b => b.classList.remove("active"));
    btn.classList.add("active");

    // 강제 갱신 (스크롤 완료 후)
    setTimeout(() => {
      ScrollTrigger.refresh();
      forcedTabIndex = null;
    }, 700); // scrollTo 애니메이션 시간 고려
  });
});

// 초기 탭 활성화
if (tabButtons.length > 0) {
  tabButtons[0].classList.add("active");
  titleEl.innerHTML = sections[0].dataset.title;
}

// ScrollTrigger - 섹션 스크롤 감지
sections.forEach((section, idx) => {
  const newTitle = section.dataset.title;

  // 내려갈 때 (onEnter) - 250px 기준
  ScrollTrigger.create({
    trigger: section,
    start: "top+=250 center",
    end: "bottom center",
    invalidateOnRefresh: true,
    onEnter: () => {
      if (forcedTabIndex === null || forcedTabIndex === idx) {
        titleEl.innerHTML = newTitle;
        updateActiveTab(idx);
      }
    }
  });

  // 올라올 때 (onEnterBack) - 150px 기준으로 더 빠르게
  ScrollTrigger.create({
    trigger: section,
    start: "top top",
    end: "bottom+=250 center",
 
    invalidateOnRefresh: true,
    onEnterBack: () => {
      if (forcedTabIndex === null || forcedTabIndex === idx) {
         console.log(`올라올 때 onEnterBack idx: ${idx}`);
        titleEl.innerHTML = newTitle;
        updateActiveTab(idx);
      }
    }
  });
});

// 탭 활성화 UI 함수
function updateActiveTab(index) {
  tabButtons.forEach((btn, i) => {
    btn.classList.toggle("active", i === index);
  });
}

// 탭 고정
ScrollTrigger.create({
  trigger: prdWrap,
  start: "top 10%",
  end: "bottom 30%",
  onUpdate: self => {
    tabs.classList.toggle("fixed", self.progress > 0 && self.progress < 1);
  }
});

// PC 고정 left_wrap
gsap.matchMedia().add("(min-width: 769px)", () => {
  const leftWraps = document.querySelectorAll(".device_left_wrap");
  const leftInitialLefts = Array.from(leftWraps).map(wrap => wrap.getBoundingClientRect().left);

  leftWraps.forEach((leftWrap, index) => {
    const isFirst = index === 0;

    ScrollTrigger.create({
      trigger: prdInner,
      start: "top top",
      end: "bottom 50%",
          
      onUpdate: self => {
        if (self.isActive) {
          Object.assign(leftWrap.style, {
            position: "fixed",
            top: "200px",
            left: `${leftInitialLefts[index]}px`,
            bottom: "auto"
          });
        } else {
          const absoluteTop = window.scrollY + 200;
          const parentTop = prdInner.getBoundingClientRect().top + window.pageYOffset;
          const topValue = isFirst ? 108 : (absoluteTop - parentTop);

          Object.assign(leftWrap.style, {
            position: "absolute",
            top: `${topValue}px`,
            left: "0px",
            bottom: "auto"
          });
        }
      }
    });
  });
});



let mobileSwiper;

gsap.matchMedia().add("(max-width: 768px)", () => {
  mobileSwiper = new Swiper(".device_tabs", {
    slidesPerView: 'auto',
    freeMode: true,
  });

  const slides = document.querySelectorAll(".device_tabs .swiper-slide");
  const sections = document.querySelectorAll(".device_section");
  const prdWrap = document.querySelector(".prd_wrap");
  const headerHeight = 0;
  let isClickScrolling = false;
  let currentActiveIndex = -1;

   slides.forEach(s => s.classList.remove("on")); // 초기화
  if (slides.length > 0) {
    slides[0].classList.add("on");
  }
  
 slides.forEach((slide, index) => {
  slide.addEventListener("click", () => {
    const targetId = slide.getAttribute("data-target");
    const section = document.getElementById(targetId);
    if (!section) return;

    isClickScrolling = true;

    // 탭 on 처리
    slides.forEach(s => s.classList.remove("on"));
    slide.classList.add("on");

    // 정확한 위치 계산
    const rect = section.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect.top + scrollTop;

    window.scrollTo({
      top: offset - 100, // ← 여기서 50은 헤더 높이 or 여유
      behavior: "smooth"
    });

    mobileSwiper.slideTo(index, 300);

    setTimeout(() => {
      isClickScrolling = false;
      currentActiveIndex = index;
    }, 500);
  });
});


window.addEventListener("scroll", () => {
  if (isClickScrolling) return;

  const scrollY = window.scrollY + 60; // 헤더 높이 등 오프셋 포함
  const prdTop = prdWrap.offsetTop;
  if (scrollY < prdTop) return;

  let foundIndex = -1;

  for (let i = sections.length - 1; i >= 0; i--) {

    const sectionTop = sections[i].getBoundingClientRect().top + window.pageYOffset;

    if (scrollY >= sectionTop) {
      foundIndex = i;
      break;
    }
  }

  if (foundIndex !== -1 && currentActiveIndex !== foundIndex) {
    currentActiveIndex = foundIndex;

    slides.forEach(s => s.classList.remove("on"));
    slides[foundIndex].classList.add("on");

    if (typeof mobileSwiper.slideTo === "function") {
      mobileSwiper.slideTo(foundIndex, 300);
    }
  }
});





});



